import React from 'react'
import CurrencyFormat from 'react-currency-format'
import { useStateValue } from './State'
import './Subtotal.css'
function Subtotal() {
  const [{cart},dispatch]=useStateValue();
  
  let amt=0;
  for(let i=0;i<cart.length;i++)
  {
    amt=amt+cart[i].price;
  }
    return (
        <div className="subtotal">
    <CurrencyFormat
        renderText={(value) => (
          <>
            <p>
              Subtotal ({cart.length} items): <strong>{value} </strong>
            </p>
            <small className="subtotal_gift">
              <input type="checkbox" /> This order contains a gift
            </small>
          </>
        )}
        decimalScale={2}
        value={amt}
        displayType="text"
        thousandSeparator={true}
        prefix={"$"}
      />
      <button>Checkout</button>
        </div>
    )
}

export default Subtotal
